module.exports = __webpack_public_path__ + "static/media/7D.30ff4b8a.svg";